module.exports = __webpack_public_path__ + "img/record.81505ed4.svg";